import cc from "classcat";
import { memo, type ReactNode } from "react";
import { useIsDashboardCustomizationEnabled } from "byzantine/src/dbbl/businessLogic/modules/userDisplayPreferences/hooks";
import SortableItem from "../../../../src/components/dragAndDrop/SortableItem";
import RowDragIndicator from "./RowDragIndicator";
import styles from "./DashboardSectionRowContainer.module.scss";

const DashboardSectionRowContainer = memo(
  ({
    id,
    isSingleChildHalfRow,
    sectionIds,
    children
  }: {
    id: string;
    isSingleChildHalfRow: boolean;
    sectionIds: string[];
    children: ReactNode;
  }) => {
    const { dashboardCustomizationLockedFields } =
      useIsDashboardCustomizationEnabled();
    const overrides =
      dashboardCustomizationLockedFields?.web_home_item_positions ?? {};

    const isOverridden = sectionIds.some((key) =>
      Object.prototype.hasOwnProperty.call(overrides, key)
    );

    return (
      <SortableItem id={id} disabled={isOverridden}>
        {({ setNodeRef, attributes, listeners, style, isDragging }) => (
          <div
            ref={setNodeRef}
            style={style}
            className={cc([
              styles["row-container"],
              isOverridden && styles["row-container--disabled"],
              isDragging && styles["row-container--dragging"],
              isSingleChildHalfRow && styles["row-container--single-child"]
            ])}
            {...attributes}
            {...listeners}
          >
            <RowDragIndicator disabled={isOverridden} />
            {children}
          </div>
        )}
      </SortableItem>
    );
  }
);

export default DashboardSectionRowContainer;
